import { lazy } from "react";
import { createBrowserRouter } from "react-router-dom";
import AuthRoutes from "./AuthRoutes";
import AdminRoutes from "./AdminRoutes";
import NotFound from "../pages/notfound";
import LazyLoad from "../common/LazyLoad";

const SharedFolder = LazyLoad(lazy(() => import("../pages/shared")));

const router = createBrowserRouter([
  AuthRoutes,
  AdminRoutes,
  {
    path: "/shared/:token",
    element: <SharedFolder />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);
export default router;
